import styled from 'styled-components';

export const Container = styled.div`
  width: 80vw;
  max-width: 1000px;
  max-height: 85vh; /* Limit the height to allow scrolling */
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 1.11rem;
  overflow: hidden; /* Prevent content from spilling out */
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 10;

  > div {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    > h3 {
      font-family: 'RedHatDisplay-Bold';
      color: #1e88e5;
      font-size: 1.2rem;
    }
  }

  svg {
    cursor: pointer;
  }
`;

export const ContentScrollable = styled.div`
  flex: 1;
  overflow-y: auto; /* Enable vertical scrolling */
  padding: 0 1rem;

  /* Styling for scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;
